import React, {useCallback, useMemo, useState} from "react";
import {ConfigProvider} from "antd";
import {keyBy, set} from "lodash";
import "./reports-management.css";
import {GenericModal} from "../../components";
import {Images} from "../../images/Images.jsx";
import {DynamicForm} from "../DynamicForm.jsx";
import {buildReportParams} from "./utils.js";

export const ReportManagement = ({reports, onSave}) => {
    const [reportForm, setReportForm] = useState({});
    const [sendRequestForExcelModal, setSendRequestForExcelModal] = useState(false);
    const [IsLoadingSendReport, setIsLoadingSendReport] = useState(false);

    const onUpdateReportForm = useCallback((_allValues, changedField) => {
        const [fieldKey, fieldValue] = Object.entries(changedField)[0];
        setReportForm(currentValues => set({...currentValues}, fieldKey, fieldValue));
    }, []);

    const fields = useMemo(() => {
        if (!reportForm?.reportName) {
            return [];
        }

        const reportSettingsByReportName = keyBy(reports, report => report?.key);
        const reportFields = Object.entries(reportSettingsByReportName[reportForm?.reportName]?.fields ?? {});

        if (!reportFields?.length) {
            return [];
        }

        return reportFields.map(([_fieldKey, properties]) => properties);
    }, [reportForm?.reportName, reports]);

    const onFinish = useCallback(
        async values => {
            setIsLoadingSendReport(true);
            const reportRequestData = buildReportParams(reports, values);
            const isSuccess = await onSave(reportRequestData);
            setIsLoadingSendReport(false);
            if (!isSuccess) {
                return;
            }
            setSendRequestForExcelModal(true);
        },
        [onSave, reports]
    );

    return (
        <div className="reports-management-container">
            <ConfigProvider direction="rtl">
                <DynamicForm
                    className="reports-management-form"
                    saveButtonTitle="ייצא דוח"
                    onUpdate={onUpdateReportForm}
                    content={reportForm}
                    onSave={onFinish}
                    fields={[
                        {
                            label: "סוג הדוח",
                            name: "reportName",
                            type: "select",
                            listHeight: 400,
                            options: reports.map(({key, value}) => ({
                                name: key,
                                label: value ?? key
                            }))
                        },
                        ...fields
                    ]}
                    isConfirmButtonLoading={IsLoadingSendReport}
                />
                <GenericModal
                    visible={sendRequestForExcelModal}
                    image={Images.areYouSure}
                    onClose={() => setSendRequestForExcelModal(false)}
                    className="report-management-sub-admins-excel-modal"
                    title="קיבלנו את בקשתך"
                    text={["יישלח אלייך בדקות הקרובות מייל עם הדוח הרלוונטי", ""]}
                    options={[
                        {
                            id: "save",
                            text: "תודה :)",
                            onClick: () => setSendRequestForExcelModal(false)
                        }
                    ]}
                />
            </ConfigProvider>
        </div>
    );
};
